import { Component, OnInit } from '@angular/core';
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { DiscountService } from 'src/app/services/vehicle/discount.service';
import { FormField } from "src/app/interfaces/form-field.model";
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-discount',
  templateUrl: './discount.component.html',
  styleUrls: ['./discount.component.css']
})
export class DiscountComponent implements OnInit {
  faPencil = faPencil;

  tableHeaders = [
    { title: "MODEL", type: "data", id: "MODEL" },
    { title: "CATEGORY", type: "data", id: "CATEGORY", classes: "max-w-64" },
    { title: "DISCOUNT", type: "data", id: "DISCOUNT" },
    { title: "SELECT", type: "checkbox", id: "SELECT" },
    { title: "ID", type: "hidden", id: "ModelMasterId" }
  ];

  coe_bidding: any[] = [];
  immediate: any[] = [];

  updateDiscounts: FormField[] = [
    {
      type: "update",
      id: "discountAmount1",
      label: "Discount Amount",
      required: true,
      searchType: "own"
    },
    {
      type: "update",
      id: "discountAmount2",
      label: "Discount Amount",
      required: true,
      searchType: "immediate"
    },
  ];

  constructor(
    private discountService: DiscountService,
    private notifier: NotifierService,
  ) {}

  ngOnInit(): void {
    this.loadDiscountData();
    this.loadImmediateDiscountData();
  }

  private loadDiscountData(): void {
    this.discountService.getModelDiscount().subscribe(
      (response) => {
        const data = response.body || [];
        
        this.coe_bidding = data.map((item: any) => {
          return {
            MODEL: item.ModelShortDesc,
            CATEGORY: item.CoeCategory,
            DISCOUNT: item.Discount,
            SELECT: false,
            ModelMasterId: item.ModelMasterId
          };
        });
  
       },
      (error) => {
        console.error("Error getting data:", error);
        this.notifier.notify('error', 'Error loading discounts.');
      }
    );
  }
  
  private loadImmediateDiscountData(): void {
    this.discountService.getModelImmediateDiscount().subscribe(
      (response) => {
        const data = response.body || [];
        this.immediate = data.map((item: any) => {
          return {
            MODEL: item.ModelShortDesc,
            CATEGORY: item.CoeCategory,
            DISCOUNT: item.Discount,
            SELECT: false,
            ModelMasterId: item.ModelMasterId
          };
        });
        },
      (error) => {
        console.error("Error getting data:", error);
        this.notifier.notify('error', 'Error loading immediate discounts.');
      }
    );
  }
  

  onUpdateEvent(event: { fieldId: string }): void {
    const field = this.updateDiscounts.find((item) => item.id === event.fieldId);
    const searchType = field?.searchType;
    const discount = Number(field?.value);

    if (field?.value === '' || field?.value === undefined || !Number.isFinite(discount)) {
      this.notifier.notify('warning', 'Discount Amount is required.');
      return;
    }
  
    if (searchType === "own") {
      if (!this.coe_bidding.some((item) => item.SELECT)) {
        this.notifier.notify('error', 'None of the models has been selected for update!');
        return;
      }

      const payload = this.coe_bidding.map(item => ({
          ModelMasterId: item.ModelMasterId,
          CoeCategory: item.CATEGORY,
          ModelShortDesc: item.MODEL,
          Discount: item.SELECT ? discount : item.DISCOUNT,
          Allowed: item.SELECT
        }));
      
      this.discountService.updateModelDiscount(payload).subscribe(
        (response) => {
          if (response?.code === 0) {
            this.notifier.notify('success', 'Discount has been updated successfully.');
            this.clearDiscountSection('own');
            this.loadDiscountData();
          } else {
            this.notifier.notify('error', response?.message || 'Error updating discount.');
          }
        },
        (error) => {
          console.error("Error updating discount:", error);
          this.notifier.notify('error', 'Error updating discount.');
        }
      );
    } else if (searchType === "immediate") {
      const selectedItems = this.immediate.filter(item => item.SELECT);
  
      if (selectedItems.length > 0) {
        const payload = selectedItems.map((item) => ({
          ModelMasterId: item.ModelMasterId,
          CoeCategory: item.CATEGORY,
          ModelShortDesc: item.MODEL,
          Discount: discount,
          Allowed: true,
        }));
       
        this.discountService.updateModelImmediateDiscount(payload).subscribe(
          (response) => {
            if (response?.code === 0) {
              this.notifier.notify('success', 'Immediate Discount has been updated successfully.');
              this.clearDiscountSection('immediate');
              this.loadImmediateDiscountData();
            } else {
              this.notifier.notify('error', response?.message || 'Error updating immediate discount.');
            }
          },
          (error) => {
            console.error("Error updating immediate discount:", error);
            this.notifier.notify('error', 'Error updating immediate discount.');
          }
        );
      } else {
        this.notifier.notify('error', 'None of the models has been selected for update!');
      }
    }
  }
  
  private clearDiscountSection(searchType: string): void {
    const field = this.updateDiscounts.find((item) => item.searchType === searchType);
    if (field) field.value = '';

    const entries = searchType === 'own' ? this.coe_bidding : this.immediate;
    entries.forEach((item) => item.SELECT = false);
  }
  
}
